"use client";

import { trackPhoneClickConversion } from "@/components/utilities/googleAdsTracking";
import {
  createWhatsAppUrl,
  trackWhatsAppClick,
} from "@/components/utilities/whatsappTracking";

interface ContactSectionProps {
  contact: {
    heading?: string;
    description?: string;
    address?: string;
    phone?: string;
    whatsapp?: string;
    email?: string;
    mapEmbedUrl?: string;
  };
}

export default function ContactSection({ contact }: ContactSectionProps) {
  const handlePhoneClick = () => {
    trackPhoneClickConversion();
  };

  const handleWhatsAppClick = () => {
    trackWhatsAppClick("campaign-contact-section");
  };

  return (
    <section className="bg-gray-50 py-12">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 px-4 md:flex-row">
        <div className="flex-1 rounded-2xl bg-white p-8 shadow">
          <h2 className="text-3xl font-bold text-violet-950">
            {contact.heading}
          </h2>
          <p className="mt-2 text-gray-600">{contact.description}</p>
          <dl className="mt-6 space-y-4 text-sm text-gray-700">
            {contact.address && (
              <div>
                <dt className="font-semibold text-violet-950">Address</dt>
                <dd className="mt-1 whitespace-pre-line">{contact.address}</dd>
              </div>
            )}
            {contact.phone && (
              <div>
                <dt className="font-semibold text-violet-950">Phone</dt>
                <dd className="mt-1">
                  <a
                    href={`tel:${contact.phone}`}
                    onClick={handlePhoneClick}
                    className="hover:underline"
                  >
                    {contact.phone}
                  </a>
                </dd>
              </div>
            )}
            {contact.whatsapp && (
              <div>
                <dt className="font-semibold text-violet-950">WhatsApp</dt>
                <dd className="mt-1">
                  <a
                    href={createWhatsAppUrl(contact.whatsapp)}
                    onClick={handleWhatsAppClick}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    {contact.whatsapp}
                  </a>
                </dd>
              </div>
            )}
            {contact.email && (
              <div>
                <dt className="font-semibold text-violet-950">Email</dt>
                <dd className="mt-1">
                  <a
                    href={`mailto:${contact.email}`}
                    className="hover:underline"
                  >
                    {contact.email}
                  </a>
                </dd>
              </div>
            )}
          </dl>
        </div>
        {contact.mapEmbedUrl && (
          <div className="flex-1 overflow-hidden rounded-2xl shadow">
            <iframe
              src={contact.mapEmbedUrl}
              title="Clinic location"
              loading="lazy"
              className="min-h-[420px] w-full"
              allowFullScreen
            ></iframe>
          </div>
        )}
      </div>
    </section>
  );
}
